import { Link, useLocation } from "react-router-dom";

export default function NavMenu() {
    const location = useLocation();

    const MENU = [
        { label: "Home", path: "/" },
        { label: "Trending", path: "/sport/trending" },
        { label: "Breaking", path: "/sport/breaking", highlight: true },
        { label: "Cricket", path: "/sport/cricket" },
        { label: "Football", path: "/sport/football" },
        { label: "Tennis", path: "/sport/tennis" },
        { label: "Basketball", path: "/sport/basketball" },
        { label: "Hockey", path: "/sport/hockey" },
        { label: "Olympics", path: "/sport/olympics" },
    ];

    const isActive = (path) => {
        if (path === "/") return location.pathname === "/";
        return location.pathname.startsWith(path);
    };

    return (
        <div className="sticky top-0 z-40 bg-white border-b shadow-sm">
            <div className="max-w-7xl mx-auto px-6">
                <ul className="
                hidden lg:flex
                items-center justify-center
                gap-8 h-14 text-sm font-semibold
                max-w-full overflow-x-hidden
                ">                    {MENU.map((item) => {
                    const active = isActive(item.path);

                    return (
                        <li key={item.label} className="relative group">
                            <Link
                                to={item.path}
                                className={`
                                        pb-2 transition-colors
                                        ${item.highlight
                                        ? "text-red-600"
                                        : active
                                            ? "text-orange-600"
                                            : "text-gray-700 hover:text-orange-600"}
                                    `}
                            >
                                {item.label}
                                <span
                                    className={`
                                            absolute left-0 -bottom-[6px] h-[2px]
                                            bg-orange-500 transition-all duration-300
                                            ${active ? "w-full" : "w-0 group-hover:w-full"}
                                        `}
                                />
                            </Link>
                        </li>
                    );
                })}
                </ul>
            </div>
        </div>
    );
}
